angular.module('cfn').factory('requiresProductLicensePopupService', [
  'CfnDialogService',
  'i18nFilter',
  '$location',
  'tracker',
  function(CfnDialogService, i18nFilter, $location, tracker) {
    var ob = {};

    ob.showDialog = function(productKey) {
      var eligibleToOrderServices = app.hasRight('Company:UPDATE'),
        productName = i18nFilter(
          'fe.sysservices.name.' + productKey.toLowerCase(),
          productKey
        ),
        title,
        message,
        button,
        actionFn;

      if (eligibleToOrderServices) {
        title = i18nFilter(
          'fe.shop.unlicensedProductPopup.admin.title',
          'Baustein nicht gebucht'
        );
        message = i18nFilter(
          'fe.shop.unlicensedProductPopup.admin.message',
          'Der Baustein "{0}" ist noch nicht gebucht. Bitte besuchen Sie unseren Shop.',
          productName
        );
        button = i18nFilter(
          'fe.shop.unlicensedProductPopup.admin.button',
          'zum Shop'
        );

        tracker.trackPageView(
          'grayedOut/' + productKey,
          'grayedOut/' + productKey
        );

        actionFn = function() {
          // track if user clicks on cta (call to action)
          tracker.trackPageView(
            'grayedOut/' + productKey + '/toModuleDetails',
            'grayedOut/' + productKey + '/toModuleDetails'
          );
          // redirect from grayed out component to corresponding shop booking popup
          $location.path('/shop/components/' + productKey);
        };
      } else {
        title = i18nFilter(
          'fe.shop.unlicensedProductPopup.basic.title',
          'Baustein nicht gebucht'
        );
        message = i18nFilter(
          'fe.shop.unlicensedProductPopup.basic.message',
          'Der Baustein "{0}" ist noch nicht gebucht. Bitte kontaktieren Sie Ihren Kontoinhaber.',
          productName
        );
        button = i18nFilter(
          'fe.shop.unlicensedProductPopup.basic.button',
          'OK'
        );
        actionFn = angular.noop;
      }

      CfnDialogService.showAckDialog(title, message, button, actionFn);
    };

    return ob;
  }
]);
